package com.shmbles.web.sections

import androidx.compose.runtime.Composable
import com.shmbles.web.components.CompanyCard
import com.shmbles.web.components.SectionTitle
import com.shmbles.web.models.Company
import com.shmbles.web.models.Section
import com.shmbles.web.util.Constants.SECTION_WIDTH
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun CompaniesSection() {
    val breakpoint = rememberBreakpoint()
    Box(
        modifier = Modifier
            .id(Section.Companies.id)
            .maxWidth(SECTION_WIDTH.px)
            .padding(topBottom = if (breakpoint >= Breakpoint.MD) 100.px else 50.px),
        contentAlignment = Alignment.Center
    ) {
        CompaniesContent()
    }
}

@Composable
fun CompaniesContent() {
    val breakpoint = rememberBreakpoint()
    Column(
        modifier = Modifier
            .fillMaxWidth(
                if (breakpoint >= Breakpoint.MD) 100.percent else 90.percent
            ),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        SectionTitle(
            modifier = Modifier
                .fillMaxWidth()
                .margin(bottom = if (breakpoint >= Breakpoint.MD) 40.px else 20.px),
            section = Section.Companies,
            alignment = Alignment.CenterHorizontally
        )
        SimpleGrid(
            numColumns = numColumns(base = 1, sm = 2, md = 3, lg = 5)
        ) {
            Company.entries.forEach { company ->
                CompanyCard(company = company)
            }
        }
    }
}
